import {
  type StatConfig,
  StatItemSchema,
} from "@repo/shared/types/graph-config";

/**
 * A stat item is only valid once it has both a `columnId` and an `operation`;
 * the server's `StatItemSchema` rejects anything missing either field. Legend
 * State's debounced partial-array sync can briefly produce items missing these
 * fields, so we strip them before they reach the server (see
 * `blocks.stat.actions.ts`).
 */
export const isValidStatItem = (item: unknown): boolean =>
  StatItemSchema.safeParse(item).success;

/**
 * Drop incomplete entries from a `statConfig.items` array. Returns the same
 * reference when nothing changes so callers can cheaply detect a no-op.
 */
export const sanitizeStatConfig = <T extends Pick<StatConfig, "items">>(
  statConfig: T,
): T => {
  const items = statConfig.items;
  if (!Array.isArray(items)) return statConfig;
  const cleaned = items.filter(isValidStatItem);
  if (cleaned.length === items.length) return statConfig;
  return { ...statConfig, items: cleaned };
};
